import {MUTATION_KEYS} from '@/queryClient.ts'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {captureException} from '@sentry/react'
import {httpLogin, HttpLoginPayload, HttpLoginResponse} from '@/features/auth/services/auth.http.ts'
import {parseAxiosPromise} from '@/axiosInstance'
import {ErrorResponseData} from '@/types'

type UseLoginOptions = {
    onSuccess?: (data: HttpLoginResponse) => void
    onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useLogin = (options?: UseLoginOptions) => {
    return useMutation({
        mutationKey: [MUTATION_KEYS.LOGIN],
        mutationFn: (payload: HttpLoginPayload) =>
            parseAxiosPromise({
                axiosPromise: httpLogin(payload),
                onZodError: captureException,
                responseShape: HttpLoginResponse
            }),
        onError: (error: AxiosError<ErrorResponseData>) => options?.onError?.(error),
        onSuccess: data => options?.onSuccess?.(data)
    })
}
